module.exports = {"540226100":"卡嘎镇","540226101":"桑桑镇","540226200":"达若乡","540226201":"贡久布乡","540226202":"措迈乡","540226203":"雄巴乡","540226204":"查孜乡","540226205":"阿木雄乡","540226206":"如萨乡","540226207":"孔隆乡","540226208":"尼果乡","540226209":"日吾其乡","540226210":"多白乡","540226211":"切热乡","540226212":"秋窝乡","540226213":"达居乡","540226214":"亚木乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540226.json
// module id = 2693
// module chunks = 0